/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { SensitivityLabelState, SensitivityLabelSlots } from './SensitivityLabel.types';

/**
 * Render the final JSX of SensitivityLabel
 */
export const renderSensitivityLabel_unstable = (state: SensitivityLabelState) => {
  assertSlots<SensitivityLabelSlots>(state);

  return (
    <state.root>
      {state.tooltip ? <state.tooltip>{state.label && <state.label />}</state.tooltip> : state.label && <state.label />}
    </state.root>
  );
};
